<template>
  <div>
    <Checkbox
      class="cb-card heading-4 weight-medium"
      title='Permanent Employment'
      v-model="income.isEmployee"
      :checked="income.isEmployee"
    >
      <ul class="body-3 weight-regular pt-5">
        <li>
          dependent work for an employer under an employment contract or equivalent labour relations
        </li>
      </ul>

      <div v-if="income.isEmployee">
        <div class="input-box-holder mt-5" v-validate="errors" v-has-value="income.employerName">
          <TextField
            class="input-box"
            v-model.trim="income.employerName"
            title='Name of Employer'
            :id="`name_${index}`"
            required
          />
          <div class="validation-output text-left mt-2">
            <ErrorHandler class="error" :id="`V047_${index}`">
              Enter the name of the employer. 
            </ErrorHandler>
          </div>
        </div>
      </div>
    </Checkbox>
  </div>
</template>
<script>
import TextField from '@/components/TextField/TextField.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import ErrorHandler from '@/components/ErrorHandler/ErrorHandler.vue';

export default {
  name: 'EmployeePackage',
  components: { Checkbox, TextField, ErrorHandler },
  props: {
    income: { type: Object, required: true },
    errors: { type: Array, required: true },
    index: { type: Number, required: true },
  },
};
</script>
